import React from 'react';
import { Box, Typography } from '@mui/material';
import SidebarNavItem from '../SidebarNavItem';
import ImageAvatar from 'ui-components/ImageAvatar';
import { ArrowRight, ChevronRight, LogOut } from 'lucide-react';

const SidebarFooter = ({
  sidebarCollapsed,
  matchesUpMd,
  userAccess,
  startupDetail,
  menuConfig,
  handleAvatarClick,
  handleLogOut,
  anchorEl,
  toggleDrawer,
}) => {
  const commonProps = {
    // This used to be `!matchesUpMd ? undefined : undefined` - undefined either
    // way - so the bottom group (Settings, Billing & Plan → Orders & Invoices,
    // Manage/Upgrade) never closed the mobile drawer on navigation, unlike every
    // item in SidebarNavigation above it.
    drawerToggle: !matchesUpMd ? toggleDrawer : undefined,
    collapsed: sidebarCollapsed,
  };

  return (
    <Box sx={{ flexShrink: 0 }}>
      <Box sx={{ px: '0', pb: '0.25rem' }}>
        {menuConfig.bottom.map((item) => (
          <SidebarNavItem key={item.label} {...item} {...commonProps} />
        ))}
      </Box>

      <Box sx={{ borderTop: '1px solid rgba(255,255,255,0.1)', mx: '0.875rem' }} />

      <Box
        onClick={handleAvatarClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.625rem',
          px: '0.875rem',
          py: '0.75rem',
          cursor: 'pointer',
          transition: 'background 0.15s ease',
          borderRadius: '6px',
          mx: '0.25rem',
          mb: '0.375rem',
          mt: '0.25rem',
          '&:hover': { backgroundColor: 'rgba(255,255,255,0.08)' },
        }}
      >
        <ImageAvatar
          height={'2.5rem'}
          width={'2.5rem'}
          style={{ borderRadius: '9px', flexShrink: 0, width: "2.5rem", height: "2.5rem" }}
          src={startupDetail?.startup_logo_path}
          alt={userAccess?.userName || ''}
        />
        {!sidebarCollapsed && (
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography
              sx={{
                fontSize: '0.8125rem',
                fontWeight: 600,
                color: 'white',
                lineHeight: 1.25,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {startupDetail?.startup_name || userAccess?.userName}
            </Typography>
            {startupDetail?.startup_name && (
              <Typography
                sx={{
                  fontSize: '0.6875rem',
                  fontWeight: 400,
                  color: 'rgba(255,255,255,0.55)',
                  lineHeight: 1.25,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {userAccess?.userName}
              </Typography>
            )}
          </Box>
        )}
        <>
        <ChevronRight
            size={13}
            color="rgba(255,255,255,0.35)" />
        </>
        {/* {!sidebarCollapsed && (
          <Box
            onClick={(e) => {
              e.stopPropagation();
              handleLogOut();
            }}
            sx={{
              display: 'flex',
              alignItems: 'center',
              p: '0.25rem',
              borderRadius: '4px',
              color: 'rgba(255,255,255,0.45)',
              flexShrink: 0,
              transition: 'color 0.15s ease',
              '&:hover': { color: 'rgba(255,255,255,0.9)' },
            }}
          >
            <LogOut size={14} />
          </Box>
        )} */}
      </Box>
    </Box>
  );
};

export default SidebarFooter;
